export default '<svg viewBox="0 0 24 24" width="24" height="24">\
    <path fill="var(--color)" d="M18.3,5.71a1,1,0,0,0-1.42,0L12,10.59,7.11,5.7A1,1,0,0,0,5.7,7.11L10.59,12,5.7,16.89a1,1,0,1,0,1.41,1.42L12,13.41l4.89,4.9a1,1,0,0,0,1.42-1.42L13.41,12l4.9-4.89A1,1,0,0,0,18.3,5.71Z"/>\
</svg>'
